import { Moon, Sun, LogOut } from "lucide-react";
import { useAuth, ROLE_LABELS } from "../../contexts/AuthContext";
import { useSentinelTheme } from "../../contexts/ThemeContext";
import { useNavigate } from "react-router-dom";
import { Button } from "../ui/button";
import { NotificationBell } from "../NotificationBell";

export function Topbar({ title }) {
  const { user, logout } = useAuth();
  const { salaControl, toggle } = useSentinelTheme();
  const navigate = useNavigate();

  return (
    <header className="flex items-center justify-between border-b border-border px-6 py-4 bg-background/80 backdrop-blur-sm sticky top-0 z-30">
      <div>
        <h1 className="text-xl font-black tracking-tight">{title}</h1>
      </div>
      <div className="flex items-center gap-4">
        <NotificationBell />
        <button
          data-testid="theme-toggle-sala-control"
          onClick={toggle}
          className="flex items-center gap-2 rounded-full border border-border px-3 py-1.5 text-xs font-bold uppercase tracking-wide transition-colors hover:bg-secondary"
        >
          {salaControl ? <Sun className="h-3.5 w-3.5 text-valoriza-leaf" /> : <Moon className="h-3.5 w-3.5" />}
          {salaControl ? "Sala de Control" : "Modo oficina"}
        </button>
        <div className="text-right hidden sm:block">
          <p className="text-sm font-bold leading-tight" data-testid="topbar-user-name">{user?.name}</p>
          <p className="text-[11px] text-muted-foreground">{ROLE_LABELS[user?.role]}</p>
        </div>
        <Button
          data-testid="logout-button"
          variant="ghost"
          size="icon"
          onClick={async () => {
            await logout();
            navigate("/login");
          }}
        >
          <LogOut className="h-4 w-4" />
        </Button>
      </div>
    </header>
  );
}
